import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";

import css from "./arrows_navigation.module.scss";

type ArrowsNavigationProps = {
  currentIndex: number;
  totalCount: number;
  prevAriaLabel: string;
  nextAriaLabel: string;
  label?: string;
  className?: string;
  onPrevClick: () => void;
  onNextClick: () => void;
};

export const ArrowsNavigation = ({
  currentIndex,
  totalCount,
  prevAriaLabel,
  nextAriaLabel,
  className,
  label,
  onPrevClick,
  onNextClick
}: ArrowsNavigationProps) => (
  <Inline className={className} alignItems="center">
    <Button
      aria-label={prevAriaLabel}
      kind="secondary"
      icon="chevron-left"
      onClick={onPrevClick}
      disabled={currentIndex === 0}
    />
    <Typography variant="bodyRegular" className={css.label}>
      {label ?? `${currentIndex + 1} / ${totalCount}`}
    </Typography>
    <Button
      aria-label={nextAriaLabel}
      kind="secondary"
      icon="chevron-right"
      onClick={onNextClick}
      disabled={currentIndex === totalCount - 1}
    />
  </Inline>
);
